import { motion } from "framer-motion";
import { Landmark, ClipboardCheck, Drill, PlugZap, ArrowRight } from "lucide-react";
import { useLanguage } from "../i18n/translations";

const ICONS = [ClipboardCheck, Landmark, Drill, PlugZap];

export const SuryaGhar = () => {
  const { t } = useLanguage();

  return (
    <section id="surya-ghar" className="relative overflow-hidden py-20 lg:py-28" data-testid="surya-ghar-banner">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[700px] -translate-x-1/2 rounded-full bg-solar/10 blur-[130px]" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="rounded-[2rem] border border-solar/30 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 p-8 shadow-[0_0_80px_rgba(245,158,11,0.12)] sm:p-12">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
            >
              <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-solar-highlight">{t.surya.eyebrow}</p>
              <h2 className="font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl lg:text-4xl">
                {t.surya.title}
              </h2>
              <p className="mt-5 leading-relaxed text-slate-400">{t.surya.desc}</p>

              <div className="mt-8 inline-flex items-end gap-4 rounded-2xl border border-eco/40 bg-eco/10 px-6 py-4">
                <div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-eco-soft">{t.surya.subsidyLabel}</div>
                  <div className="font-mono text-4xl font-black text-eco-bright">₹1,08,000</div>
                  <div className="mt-1.5 text-xs font-semibold text-slate-400">{t.surya.subsidyBreak}</div>
                </div>
              </div>

              <div className="mt-8">
                <a
                  href="#contact"
                  data-testid="surya-ghar-eligibility-btn"
                  className="group inline-flex items-center gap-2 rounded-full bg-solar px-7 py-3.5 text-sm font-bold text-amber-950 transition-colors duration-300 hover:bg-solar-yellow"
                >
                  {t.surya.cta}
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </div>
            </motion.div>

            <div className="grid gap-4 sm:grid-cols-2">
              {t.surya.steps.map((s, i) => {
                const Icon = ICONS[i];
                return (
                  <motion.div
                    key={s.t}
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className="rounded-2xl border border-white/10 bg-navy-950/60 p-5 transition-colors duration-300 hover:border-solar/40"
                    data-testid={`surya-step-${i + 1}`}
                  >
                    <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-solar/15">
                      <Icon size={20} className="text-solar-yellow" />
                    </div>
                    <div className="font-mono text-[10px] font-bold uppercase tracking-widest text-slate-500">Step {i + 1}</div>
                    <h3 className="mt-1 font-display text-base font-bold text-white">{s.t}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{s.d}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
